
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { SearchService } from '../../search/search.service';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { SearchEvent } from '../../search/models/search-event';
import { NEW_SEARCH_EVENT } from '../../search/search-constants';

@Component({
  selector: 'lfwms-search-filter-popup',
  templateUrl: './search-filter-popup.component.html',
  styleUrls: ['./search-filter-popup.component.css']
})
export class SearchFilterPopupComponent implements OnInit, OnDestroy {

  public isLoading: boolean = true;
  public searchService: SearchService;
  public eventSubscription: Subscription;

  constructor(private sharedServiceRegistry: SharedServiceRegistry) {}

  public ngOnInit() {
    this.eventSubscription = this.searchService.receiveEvent()
      .subscribe(($event: SearchEvent) => {
        if ($event.type === NEW_SEARCH_EVENT) {
          this.sharedServiceRegistry.sceModalService.modalReference.hide();
        }
      });
    this.isLoading = false;
  }

  public ngOnDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/search-filter-popup/search-filter-popup.component.ts